const ItemData = [
  {
    id: 1,
    name: '간식1',
    price: 1000,
    image: '이미지'
  },
  {
    id: 2,
    name: '간식2',
    price: 2000,
    image: '이미지'
  },
  {
    id: 3,
    name: '간식3',
    price: 3000,
    image: '이미지'
  },
  {
    id: 4,
    name: '간식4',
    price: 4000,
    image: '이미지'
  },
  {
    id: 5,
    name: '간식5',
    price: 5000,
    image: '이미지'
  },
  {
    id: 6,
    name: '간식6',
    price: 6000,
    image: '이미지'
  },
  {
    id: 7,
    name: '간식7',
    price: 7000,
    image: '이미지'
  },
  {
    id: 8,
    name: '간식8',
    price: 8000,
    image: '이미지'
  },
]


export default ItemData;